/* Pay-online (prepaid code at Shopify checkout) + Releasit COD funnel — 20 Oct 2026
   - [data-buy-prepaid]: adds the selected variant to the cart, then opens Shopify checkout with the prepaid code.
   - [data-prepaid-checkout]: cart checkout button, same checkout URL (saves the cart note first).
   - [data-sticky-cod]: sticky-bar Cash on delivery, opens the Releasit form via its own button.
   Shopify keeps a checkout discount code on the storefront cart, so when a shopper comes back from checkout
   the code is removed from the cart again (and the cart drawer re-rendered). Releasit buttons wait for that
   clean-up, so COD orders never carry the pay-online code. */
(() => {
  const cfg = window.BARE_FUNNEL || {};
  if (!cfg.code) return;
  const code = String(cfg.code).toUpperCase();
  const checkoutUrl = () => `/checkout?discount=${encodeURIComponent(cfg.code)}`;
  const RSI_SELECTOR = '#rsi_buy_now_button, ._rsi-buy-now-button, .rsi_buy_now_button, #floatingBuyNowButton';

  // ---- Keep the pay-online code off the storefront cart ----
  let cleaning = null;
  async function rerenderCart() {
    const ids = [];
    if (document.querySelector('[data-cart-drawer-inner]')) ids.push('cart-drawer');
    const page = document.querySelector('[data-cart-page]');
    if (page && page.dataset.sectionId) ids.push(page.dataset.sectionId);
    if (!ids.length) return;
    const res = await fetch(`${window.location.pathname}?sections=${ids.join(',')}`);
    if (!res.ok) return;
    const sections = await res.json();
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
    if (sections['cart-drawer']) {
      const fresh = parse(sections['cart-drawer']).querySelector('[data-cart-drawer-inner]');
      const current = document.querySelector('[data-cart-drawer-inner]');
      if (fresh && current) { current.innerHTML = fresh.innerHTML; current.dataset.cartCountValue = fresh.dataset.cartCountValue; }
    }
    if (page && sections[page.dataset.sectionId]) {
      const fresh = parse(sections[page.dataset.sectionId]).querySelector('[data-cart-page]');
      if (fresh) page.innerHTML = fresh.innerHTML;
    }
  }
  function stripPrepaidCode() {
    cleaning = (async () => {
      try {
        const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        const codes = (cart.discount_codes || []).map((d) => d.code);
        if (!codes.some((c) => String(c).toUpperCase() === code)) return;
        const keep = codes.filter((c) => String(c).toUpperCase() !== code);
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: keep.join(',') }) });
        await rerenderCart();
      } catch (_) { /* best effort */ }
    })();
    return cleaning;
  }
  stripPrepaidCode();
  window.addEventListener('pageshow', (e) => { if (e.persisted) stripPrepaidCode(); });
  const rsiButton = () =>
    document.querySelector('[data-main-buy-buttons] .product-form > #rsi_buy_now_button') ||
    document.querySelector('.product-form > #rsi_buy_now_button') ||
    document.querySelector('#rsi_buy_now_button');

  function showError(form, message) {
    const el = form && form.querySelector('[data-form-error]');
    if (el) { el.textContent = message; el.hidden = false; } else { window.alert(message); }
  }

  async function buyPrepaid(btn) {
    const form = document.getElementById(btn.dataset.form) || btn.closest('form');
    if (!form) return;
    const atc = form.querySelector('[data-add-to-cart]');
    if (atc && atc.disabled && !atc.classList.contains('is-loading')) { showError(form, atc.textContent.trim() || 'Sold out'); return; }
    btn.classList.add('is-loading');
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Could not add this item. Please try again.');
      }
      window.location.href = checkoutUrl();
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      showError(form, err.message);
    }
  }

  function cartTermsAccepted(form) {
    const terms = form && form.querySelector('[data-cart-terms]');
    if (!terms || terms.checked) return true;
    terms.focus();
    terms.reportValidity();
    return false;
  }

  async function followCartLink(link) {
    const form = link.closest('form');
    if (!cartTermsAccepted(form)) return;
    const note = form && form.querySelector('[name="note"]');
    if (note) {
      try {
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
      } catch (_) { /* note is optional */ }
    }
    window.location.assign(link.href);
  }

  window.addEventListener('click', (e) => {
    // Releasit COD buttons: wait for the clean-up above before the COD form reads the cart.
    const rsi = e.target.closest(RSI_SELECTOR);
    if (rsi && cleaning && !rsi.dataset.bareReady) {
      e.preventDefault();
      e.stopImmediatePropagation();
      cleaning.finally(() => {
        cleaning = null;
        rsi.dataset.bareReady = '1';
        rsi.click();
        delete rsi.dataset.bareReady;
      });
      return;
    }
    const buy = e.target.closest('[data-buy-prepaid]');
    if (buy) {
      e.preventDefault();
      e.stopPropagation();
      if (!buy.disabled && !buy.classList.contains('is-loading')) buyPrepaid(buy);
      return;
    }
    const prepaidLink = e.target.closest('[data-prepaid-checkout-link]');
    if (prepaidLink) {
      e.preventDefault();
      e.stopImmediatePropagation();
      followCartLink(prepaidLink);
      return;
    }
    const codLink = e.target.closest('[data-cart-cod]');
    if (codLink) {
      e.preventDefault();
      e.stopImmediatePropagation();
      followCartLink(codLink);
      return;
    }
    const cod = e.target.closest('[data-sticky-cod]');
    if (cod) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const rsi = rsiButton();
      if (rsi) rsi.click();
    }
  }, true);

  // Cart drawer "Cash on delivery" links to /cart?cod=1; open Releasit's cart COD form there once it renders.
  if (window.location.pathname === '/cart' && /[?&]cod=1/.test(window.location.search)) {
    // Releasit renders its button before its click handler is ready, so click, check the form opened, retry.
    let n = 0;
    const formOpen = () => !!document.querySelector('#rsi_form_wrapper, [class*="rsi-form"], [id*="rsi-cod-form"]') || /COD handling fee/i.test(document.body.innerText);
    const openCod = () => {
      if (formOpen()) return;
      const btn = document.querySelector('#cart-wrapper #rsi_buy_now_button, #cart-wrapper ._rsi-buy-now-button, #cart-wrapper .rsi_buy_now_button, #rsi_buy_now_button');
      if (btn) btn.click();
      if (n++ < 20) setTimeout(openCod, 1500);
    };
    setTimeout(openCod, 1500);
  }

  // Show the sticky Cash on delivery button only once Releasit has rendered its button.
  let tries = 0;
  const syncCod = () => {
    const has = !!rsiButton();
    document.querySelectorAll('[data-sticky-cod]').forEach((b) => { b.hidden = !has; });
    if (!has && tries++ < 40) setTimeout(syncCod, 500);
  };
  syncCod();
})();
